import { useCallback } from 'react';
import { useEpisodes } from '@contexts/EpisodesContext';
import { useAudioPlayer } from '@contexts/AudioPlayerContext';

export function useAllEpisodesPageController() {
  const { episodes, loading, error } = useEpisodes();
  const { toggleEpisodePlayback } = useAudioPlayer();

  const handlePlayClick = useCallback((episode) => {
    toggleEpisodePlayback(episode);
  }, [toggleEpisodePlayback]);

  return {
    episodes,
    loading,
    error,
    onPlayClick: handlePlayClick
  };
}
